import { Auth } from 'aws-amplify'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import UpdateMovieListStatusService from '../../Services/Mutations/UpdateMovieListStatusService'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import { ToastStyle } from '../Data/MovieStaticData'
import LoadingSpinner from '../Movie/Loading'
import CreateListNameAndDescription from './CreateListNameAndDescription'
import CreateListPoster from './CreateListPoster'
import TaggedmoviePersonandSearch from './TaggedmoviePersonandSearch'
import TagHeadearLevel from './TagHeadearLevel'

export default function Createlist(props) {
  const {
    editMovieCatogary,
    listDetails,
    editMode,
    // TaggedpersonsFromService,
    MOvieListId,
    // initialAllTaggedPersons,
    listID,
    initialHeaderPersons,
    editmovieListStatus,
  } = props
  const history = useHistory()
  // const navigate = useNavigate()
  const [valueEdited, setvalueEdited] = useState(false)
  const [loadPopup, setLoadPopup] = useState(false)
  const [selectedListType, setSelectedListType] = useState('')
  const [listData, setListData] = useState({})
  const [loadSpinner, setLoadSpinner] = useState(false)
  const [ApproveOption, setApproveOptionBoolean] = useState(false)
  const [listId, setListId] = useState('')
  const [movieListStatus, setmovieListStatus] = useState('draft')
  const [imagePreview, setImagePreview] = useState('')
  const [HorizontalImage, setHorizontalImage] = useState(false)
  const headerRef = useRef(null)
  const [selectedMovieOrPersonData, setSelectedMovieOrPersonData] = useState([])
  const handleSelectedListType = event => {
    setSelectedListType(event.target.value)
  }

  const sendLoadSpinner = data => {
    setLoadSpinner(data)
  }

  const sendSelectedListType = data => {
    setSelectedListType(data)
  }

  const sendListData = data => {
    setListData(data)
  }

  const handleListData = (key, value) => {
    const data = { ...listData }
    data[key] = value
    setListData(data)
    setvalueEdited(true)
  }

  const navigateTOpage = listId => {
    if (editMode === 'edit') {
      setTimeout(() => {
        history.go(`editlist?${listId.replace('#', '$')}`)
        setLoadSpinner(false)
      }, 3000)
    } else {
      setTimeout(() => {
        window.open('editlist?' + encodeURI(listId.replace('#', '$')), '_self')
        setLoadSpinner(false)
      }, 3000)
    }
  }

  const clearAll = listId => {
    headerRef.current.handlePersonChanges()
    // headerRef.current.unTagPearsonHeader()
    if (ApproveOption && movieListStatus === 'draft') {
      setLoadSpinner(false)
      setTimeout(() => {
        setLoadPopup(true)
      }, 3000)
    } else {
      setTimeout(() => {
        navigateTOpage(listId)
      }, 6000)
    }
  }

  const approveCollection = async () => {
    setLoadSpinner(true)
    const response = await UpdateMovieListStatusService({
      movieListID: listId,
      status: 'published',
    })

    if (response.statusCode === 'M022') {
      toast.success(response.statusMessage, ToastStyle)
      setTimeout(() => {
        navigateTOpage(listId)
      }, 3000)
    }
  }

  const ClosePopup = () => {
    navigateTOpage(listId)
  }

  const createListValidation = () =>
    !(
      listData.title_en &&
      listData.title_te &&
      listData.description_en &&
      listData.description_te &&
      imagePreview &&
      HorizontalImage
    )

  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.map(item => {
          permissions.push(...item.permissions)
          return item
        })
        permissions.map(permission => {
          permissionsArr.push(permission.name)
          return permission
        })
      }

      const EDitApproveOption = permissionsArr.includes(
        DefinedPermissions.DisplayApproveMovieOption,
      )

      setApproveOptionBoolean(EDitApproveOption)
    }

    getPermissions()
  }, [])
  useEffect(() => {
    setSelectedListType(editMovieCatogary)
    setListData(listDetails ? listDetails : {})
    setListId(listID ? listID : '')
    setmovieListStatus(editmovieListStatus ? editmovieListStatus : '')

    setImagePreview(listDetails && listDetails.movieListImage ? listDetails.movieListImage : '')
  }, [listDetails, editMovieCatogary, listID])

  return (
    <div>
      {loadSpinner && <LoadingSpinner />}
      <label>{editMode === 'edit' ? 'Edit List' : 'Create List'}</label>
      <div className='tinput'>
        <div className='currentlyactive-style' style={{ display: 'flex', gap: '10px' }}>
          {/* radio buttons to select movie or Person */}
          <input
            id='movie'
            type='radio'
            name='movie or person'
            value='Movie'
            checked={selectedListType === 'Movie'}
            onChange={handleSelectedListType}
          />
          <div htmlFor='movie' onClick={() => setSelectedListType('Movie')}>
            Movie
          </div>
          <input
            id='person'
            type='radio'
            name='movie or person'
            value='Person'
            checked={selectedListType === 'Person'}
            onChange={handleSelectedListType}
          />
          <div htmlFor='person' onClick={() => setSelectedListType('Person')}>
            Person
          </div>

          <input
            id='text'
            type='radio'
            name='movie or person'
            value='Text'
            checked={selectedListType === 'Text'}
            onChange={handleSelectedListType}
          />
          <div htmlFor='person' onClick={() => setSelectedListType('Text')}>
            Text
          </div>
          <br></br>
        </div>
      </div>
      {selectedListType && (
        <>
          <CreateListNameAndDescription listData={listData} handleListData={handleListData} />
          <TagHeadearLevel
            editMode={editMode}
            ref={headerRef}
            movieListID={listId}
            initialHeaderPersons={initialHeaderPersons}
            selectedMovieOrPersonData={selectedMovieOrPersonData}
            setSelectedMovieOrPersonData={setSelectedMovieOrPersonData}
            selectedListType={selectedListType}
            setvalueEdited={setvalueEdited}
            sendLoadSpinner={sendLoadSpinner}
          />
          <CreateListPoster
            selectedListType={selectedListType}
            imagePreview={imagePreview}
            setImagePreview={setImagePreview}
            HorizontalImage={HorizontalImage}
            setHorizontalImage={setHorizontalImage}
            setvalueEdited={setvalueEdited}
          />
          <TaggedmoviePersonandSearch
            // TaggedpersonsFromService={TaggedpersonsFromService}
            selectedListType={selectedListType}
            editMode={editMode}
            listData={listData}
            sendLoadSpinner={sendLoadSpinner}
            sendSelectedListType={sendSelectedListType}
            editListData={props.editListData}
            sendListData={sendListData}
            MOvieListId={MOvieListId}
            // initialAllTaggedPersons={initialAllTaggedPersons}
            clearAll={clearAll}
            loadPopup={loadPopup}
            setLoadPopup={setLoadPopup}
            setListId={setListId}
            imagePreview={imagePreview}
            createListValidation={createListValidation}
            valueEdited={valueEdited}
            setvalueEdited={setvalueEdited}
            selectedMovieOrPersonData={selectedMovieOrPersonData}
            setSelectedMovieOrPersonData={setSelectedMovieOrPersonData}
            // setLoadSpinner={setLoadSpinner}
          />
          <Modal
            show={loadPopup}
            dialogClassName='modal-90w'
            // fullscreen={'md-down'}
            onHide={() => ClosePopup()}
          >
            <Modal.Header closeButton>
              <Modal.Title>Approve</Modal.Title>
            </Modal.Header>
            <Modal.Body>{'Are you Sure to Approve this MovieList'}</Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={() => ClosePopup()}>
                Close
              </Button>
              <Button variant='primary' onClick={() => approveCollection()}>
                Approve
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </div>
  )
}
